/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PaymentOpsPaymentEventDto
 */
export interface PaymentOpsPaymentEventDto {
    /**
     * 
     * @type {number}
     * @memberof PaymentOpsPaymentEventDto
     */
    paymentId: number;
    /**
     * 
     * @type {string}
     * @memberof PaymentOpsPaymentEventDto
     */
    paymentReference: string;
    /**
     * 
     * @type {number}
     * @memberof PaymentOpsPaymentEventDto
     */
    sequence: number;
    /**
     * 
     * @type {PaymentOpsPaymentEventDtoOldStateEnum}
     * @memberof PaymentOpsPaymentEventDto
     */
    oldState?: PaymentOpsPaymentEventDtoOldStateEnum;
    /**
     * 
     * @type {PaymentOpsPaymentEventDtoNewStateEnum}
     * @memberof PaymentOpsPaymentEventDto
     */
    newState?: PaymentOpsPaymentEventDtoNewStateEnum;
    /**
     * 
     * @type {PaymentOpsPaymentEventDtoEventCodeEnum}
     * @memberof PaymentOpsPaymentEventDto
     */
    eventCode: PaymentOpsPaymentEventDtoEventCodeEnum;
    /**
     * 
     * @type {string}
     * @memberof PaymentOpsPaymentEventDto
     */
    payload?: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentOpsPaymentEventDto
     */
    created: Date;
}


/**
 * @export
 */
export const PaymentOpsPaymentEventDtoOldStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type PaymentOpsPaymentEventDtoOldStateEnum = typeof PaymentOpsPaymentEventDtoOldStateEnum[keyof typeof PaymentOpsPaymentEventDtoOldStateEnum];

/**
 * @export
 */
export const PaymentOpsPaymentEventDtoNewStateEnum = {
    INITIATING: 'INITIATING',
    AWAITING_PAYMENT: 'AWAITING_PAYMENT',
    AUTHORISING: 'AUTHORISING',
    AUTHORISED: 'AUTHORISED',
    CAPTURING: 'CAPTURING',
    CAPTURED: 'CAPTURED',
    PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
    FULLY_REFUNDED: 'FULLY_REFUNDED',
    FAILED: 'FAILED',
    UNKNOWN: 'UNKNOWN',
    REFUNDING: 'REFUNDING'
} as const;
export type PaymentOpsPaymentEventDtoNewStateEnum = typeof PaymentOpsPaymentEventDtoNewStateEnum[keyof typeof PaymentOpsPaymentEventDtoNewStateEnum];

/**
 * @export
 */
export const PaymentOpsPaymentEventDtoEventCodeEnum = {
    INITIATE: 'INITIATE',
    INITIATE_FAILED: 'INITIATE_FAILED',
    SEND_FOR_PAYMENT: 'SEND_FOR_PAYMENT',
    REDIRECT_SHOPPER: 'REDIRECT_SHOPPER',
    PAYMENT_CANCELLED: 'PAYMENT_CANCELLED',
    COMPLETE_WITHOUT_PAYMENT: 'COMPLETE_WITHOUT_PAYMENT',
    AUTHORISE: 'AUTHORISE',
    AUTHORISE_FAILED: 'AUTHORISE_FAILED',
    AUTHORISE_SUCCEEDED: 'AUTHORISE_SUCCEEDED',
    CAPTURE: 'CAPTURE',
    CAPTURE_SUCCEEDED: 'CAPTURE_SUCCEEDED',
    CAPTURE_FAILED: 'CAPTURE_FAILED',
    REFUND: 'REFUND',
    REFUND_SUCCEEDED: 'REFUND_SUCCEEDED',
    REFUND_FAILED: 'REFUND_FAILED',
    STATE_UNDETERMINED: 'STATE_UNDETERMINED',
    STATE_IN_PROGRESS: 'STATE_IN_PROGRESS',
    MANUAL_STATE_OVERRIDE: 'MANUAL_STATE_OVERRIDE'
} as const;
export type PaymentOpsPaymentEventDtoEventCodeEnum = typeof PaymentOpsPaymentEventDtoEventCodeEnum[keyof typeof PaymentOpsPaymentEventDtoEventCodeEnum];


/**
 * Check if a given object implements the PaymentOpsPaymentEventDto interface.
 */
export function instanceOfPaymentOpsPaymentEventDto(value: object): value is PaymentOpsPaymentEventDto {
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    if (!('paymentReference' in value) || value['paymentReference'] === undefined) return false;
    if (!('sequence' in value) || value['sequence'] === undefined) return false;
    if (!('eventCode' in value) || value['eventCode'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function PaymentOpsPaymentEventDtoFromJSON(json: any): PaymentOpsPaymentEventDto {
    return PaymentOpsPaymentEventDtoFromJSONTyped(json, false);
}

export function PaymentOpsPaymentEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentOpsPaymentEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentId': json['paymentId'],
        'paymentReference': json['paymentReference'],
        'sequence': json['sequence'],
        'oldState': json['oldState'] == null ? undefined : json['oldState'],
        'newState': json['newState'] == null ? undefined : json['newState'],
        'eventCode': json['eventCode'],
        'payload': json['payload'] == null ? undefined : json['payload'],
        'created': (new Date(json['created'])),
    };
}

export function PaymentOpsPaymentEventDtoToJSON(json: any): PaymentOpsPaymentEventDto {
    return PaymentOpsPaymentEventDtoToJSONTyped(json, false);
}

export function PaymentOpsPaymentEventDtoToJSONTyped(value?: PaymentOpsPaymentEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentId': value['paymentId'],
        'paymentReference': value['paymentReference'],
        'sequence': value['sequence'],
        'oldState': value['oldState'],
        'newState': value['newState'],
        'eventCode': value['eventCode'],
        'payload': value['payload'],
        'created': value['created'].toISOString(),
    };
}

